import { CheckboxOptionType } from 'antd';
import { NotificationType } from 'common/enums/notification-type.enum';

export const NotificationCheckboxOptions: CheckboxOptionType[] = [
  { label: 'I accept Email communication', value: NotificationType.Email },
  { label: 'I accept SMS communication', value: NotificationType.SMS },
];
